export default "__VITE_ASSET__B6Eqrr2O__"